import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { IconButton, Tooltip } from '@mui/material';
import { MouseEvent } from 'react';
import { useIntl } from 'react-intl';
import { impersonationMessages } from '../impersonation-messages';

type ImpersonationOpenInNewTabButtonProps = {
  onClick: () => void;
};

/**
 * Opens tab-scoped impersonation in a new browser tab.
 * Stops mousedown/click so parent list/autocomplete rows do not select or persist.
 */
export function ImpersonationOpenInNewTabButton({ onClick }: ImpersonationOpenInNewTabButtonProps) {
  const { $t } = useIntl();
  const label = $t(impersonationMessages.openInNewTabAriaLabel);

  function handleMouseDown(event: MouseEvent) {
    // Autocomplete selects on mousedown; block that so only the new-tab action runs.
    event.preventDefault();
    event.stopPropagation();
  }

  function handleClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    onClick();
  }

  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        aria-label={label}
        onMouseDown={handleMouseDown}
        onClick={handleClick}
      >
        <OpenInNewIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
